import { useState, useRef, useEffect } from 'react'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import calendar from './img/calendar.svg'
import ru from 'date-fns/locale/ru'
import { CalendarContainer } from 'react-datepicker';
import './SingleDatePicker.scss'
import { TextPage } from '../TextPage/TextPage';

const SingleDatePicker = ({
    required,
    placeholder,
    style,
    range,
    setDate,
    date,
    disabled,
    time,
    filterTime = false,
    size = 's',
    ...props
}) => {

    const datePickerRef = useRef(null)

    const filterPassedTime = (time) => {
        const currentDate = new Date();
        const selectedDate = new Date(time);

        return currentDate.getTime() < selectedDate.getTime();
    };

    const MyContainer = ({ className, children }) => {

        return (
            <div className='calendar_wrapper_single'>

                <CalendarContainer className={className}>
                    <div style={{ position: "relative" }}>{children}</div>
                </CalendarContainer>
            </div>
        );
    }


    return (
        <div className='single-date-picker__wrapper'>
            {placeholder &&
                <TextPage
                    text={<>{placeholder}{required ? <span style={{ color: 'red' }}> *</span> : ""}</>}
                />}
            <div
                onClick={() => datePickerRef.current.setFocus()}
                className={disabled ? 'single-date-picker_grey' : 'single-date-picker'}
                style={style ? style : {}}>

                <DatePicker
                    ref={datePickerRef}
                    selected={date}
                    disabled={disabled}
                    showTimeSelect={time ? true : false}
                    dateFormat={time ? 'dd.MM.yyyy HH:mm' : 'dd.MM.yyyy'}
                    onChange={(date) => setDate(date)}
                    locale={ru}
                    filterTime={filterTime ? filterPassedTime : null}
                    calendarContainer={MyContainer}
                    calendarClassName="date-picker-custom"
                    {...props}
                />
                <img className='icon-img' src={calendar} />
            </div>
        </div>
    );
};

export { SingleDatePicker }